import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  OnInit,
  Output,
  input,
} from '@angular/core';

import { IconSpriteModule } from '@personal-area/icon-sprite';

import { DepositBonusTrackingService } from '../services/deposit-bonus-tracking.service';

type BannerType = 'bonus-verified' | 'bonus-unverified';
export const bonusBannerClosed = 'bonusBannerClosed';

@Component({
  selector: 'global-bonus-banner',
  templateUrl: './bonus-banner.component.html',
  styleUrls: ['./bonus-banner.component.scss'],
  standalone: true,
  imports: [IconSpriteModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BonusBannerComponent implements OnInit {
  bannerType = input.required<BannerType>();
  text = input.required<string>();
  @Output() bonusBannerClosed = new EventEmitter();

  constructor(
    private readonly _depositBonusTrackingService: DepositBonusTrackingService,
  ) {}

  public close(event: Event): void {
    event.stopPropagation();
    this.bonusBannerClosed.emit();
  }

  ngOnInit(): void {
    if (this.bannerType() === 'bonus-verified') {
      this._depositBonusTrackingService.alertDepositBonusViewed();

      return;
    }

    this._depositBonusTrackingService.bannerDepositBonusViewed();
  }

  @HostBinding('class')
  get hostClass(): string {
    return this.bannerType();
  }
}
